import { AgentHub } from "@/components/agents/agent-hub.tsx";
import { m } from "@/paraglide/messages.js";
import { agentDefinitionQueryOptions } from "@/services/agent-definitions-service.ts";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute(
	"/_authenticated/dashboard/agents/$agentId/",
)({
	component: RouteComponent,
	head: () => ({
		meta: [{ title: pageTitle(m.agent_builder_title()) }],
	}),
});

function RouteComponent() {
	const { agentId } = Route.useParams();
	// The hub is viewable by anyone who can see the agent (viewers, designated
	// approvers), so no manage-bounce here — edit actions inside the hub gate on
	// canManageAgent themselves.
	const { data } = useSuspenseQuery(agentDefinitionQueryOptions(agentId));
	return <AgentHub agent={data} />;
}
